import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { IdNameModel } from "services/KnowfullyAdminClient";

type SelectQuestionValidationRuleProps = Omit<
  AutocompleteWithQueryProps<IdNameModel>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectQuestionValidationRule = (
  props: SelectQuestionValidationRuleProps,
) => {
  const { formatMessage: t } = useIntl();
  const { licenseService } = useGlobalContext();

  const rules = useQuery("licenseService.getQuestionValidationRules", () =>
    licenseService.getQuestionValidationRules(),
  );

  return (
    <AutocompleteWithQuery
      {...props}
      labelField="name"
      fetchedData={rules}
      failMessage={t({ id: "fetchError" })}
    />
  );
};

export default SelectQuestionValidationRule;
